import { isCapabilitySupported } from "owa-capabilities";
import { addinsCapability } from "owa-capabilities-definitions/lib/addinsCapability";
import type { M365Acquisition } from "owa-graph-schema";
import type { MailboxInfo } from "owa-client-types";
import type { StrictAcquisition } from "../types";

export function acquisitionsAllowedByPrivacy(acquisition: M365Acquisition | StrictAcquisition, mailboxInfo?: MailboxInfo): boolean {
    if (!isCapabilitySupported(addinsCapability, mailboxInfo) &&
        acquisition.acquisitionContext === "User") {
        return false;
    }
    return true;
}
